import LockupAudioTrackInfo from './lockupAudioTrackInfo'

export default LockupAudioTrackInfo
